import { render, staticRenderFns } from "./smsCodeComponent.vue?vue&type=template&id=660e31e4&scoped=true"
import script from "./smsCodeComponent.vue?vue&type=script&lang=js"
export * from "./smsCodeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660e31e4",
  null
  
)

export default component.exports